export function decodeString(string: string | null | undefined) {
	return string
		?.replaceAll('#', ';')
		.split('')
		.map((c: string) => String.fromCharCode(c.charCodeAt(0) + 13))
		.join('');
}
